export enum App {
  CDC = 0,
  CRM_SALESFORCE = 1,
  CONTENT = 2,
  SOPROD = 3,
  BUS_FLASH = 4,
  CUSTOMER_PROFILE = 5,
  ICARD = 6
}
